import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const SUBSCRIPTIONS_QUERY = gql`
  query Subscriptions {
    subscriptions {
      id
      startDate
      nextInvoiceDate
      nextInvoiceAmountCents
      currency
      paymentInterval
      endDate
      trialing
      status
      cancelAt
      discount {
        promoCode
        percentOff
      }
      items {
        productId
        productName
        priceId
        quantity
      }
    }
  }
`;

export interface SubscriptionDiscountInfo {
  promoCode: string;
  percentOff: number;
}

export interface SubscriptionProductInfo {
  productId: string;
  productName: string;
  priceId: string;
  quantity: number;
}

export interface SubscriptionInfo {
  id: string;
  startDate: string; // ISO 8601
  nextInvoiceDate: string | null; // ISO 8601 or null
  nextInvoiceAmountCents: number | null;
  currency: string; // e.g., 'eur'
  paymentInterval: string; // 'month' | 'year'
  endDate: string; // ISO 8601
  trialing: boolean;
  status: string;
  cancelAt?: string | null;
  discount?: SubscriptionDiscountInfo | null;
  items: SubscriptionProductInfo[];
}

export interface SubscriptionsResult {
  subscriptions: SubscriptionInfo[];
}

export function useSubscriptionsQuery(options?: QueryHookOptions<SubscriptionsResult>) {
  return useQuery<SubscriptionsResult>(SUBSCRIPTIONS_QUERY, options);
}
